export interface MenuToJsonDtoModifier {
  modifierName: string;
  modifierDescription: string;
  modifierPrice: number;
  modifierGroup: string;
  modifierAllergens: string[];
  modifierCategoryLevel1: string;
  modifierCategoryLevel2: string;
  modifierCategoryLevel3: string;
}

export interface MenuToJsonDtoProduct {
  productName: string;
  productDescription: string;
  productPrice: number;
  productAllergens: string[];
  productCategoryLevel1: string;
  productCategoryLevel2: string;
  productCategoryLevel3: string;
  modifiers: MenuToJsonDtoModifier[];
}

export interface MenuToJsonDtoMenuCategory {
  categoryName: string;
  categoryDescription: string;
  products: MenuToJsonDtoProduct[];
}

export interface MenuToJsonDtoMenuHour {
  weekDay: string;
  openTime: string;
  closeTime: string;
}

export class MenuToJsonDto {
  menu: {
    menuCategories: MenuToJsonDtoMenuCategory[];
    menuHours: MenuToJsonDtoMenuHour[];
  }
}